<template>
	<div class="gradient py-8 my-8 -mx-6 px-4 product-card-white">
		<!-- Header -->
		<div class="flex items-center justify-between mb-3">
			<h3 class="text-lg font-semibold text-ihh-midnight-gray">You May Also Like</h3>
		</div>

		<!-- Grid scroller -->
		<div ref="gridWrap" class="relative">
			<div ref="grid" class="upsell-grid grid grid-cols-2 sm:grid-cols-3 gap-3 overflow-y-auto pr-1" style="max-height: 540px">
				<Product
					v-for="p in filteredProducts"
					:product="p"
					:key="p.id"
					:hideReviews="true"
					:small="true"
					:isUpsellItem="true"
					:hidePrice="true"
					:clampName2="true"
					class="upsell-item"
				/>
			</div>

			<!-- Subtle scroll hint -->
			<div v-show="showScrollHint" class="pointer-events-none absolute bottom-0 left-0 right-0 h-14 flex items-end justify-center">
				<div class="w-full h-14 bg-gradient-to-t from-ihh-midnight-gray/10 to-transparent flex items-end justify-center">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="w-6 h-6 mb-2 text-ihh-midnight-gray/80 animate-bounce filter drop-shadow"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					>
						<path d="M6 9l6 6 6-6" />
					</svg>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Mango from '../../helpers/mango'
import Product from '../products/product.vue'
import { algoliaAppId, algoliaSearchKey, algoliaIndex } from '../../../../config/config/settings.json'
import { algoliasearch } from 'algoliasearch'

const recommend = algoliasearch(algoliaAppId, algoliaSearchKey).initRecommend()

export default {
	components: { Product },
	inject: ['store'],
	data() {
		return {
			upsellItems: [],
			scrollerRef: null,
			recommended: [],
			showScrollHint: false,
		}
	},

	methods: {
		async getUpsellItems() {
			if (!this.lastCartProduct?.id) {
				let productIdsInCart = this.store.cart?.cartItems?.map?.((c) => c.item.bcId)
				let upsellIds = [862, 4069, 2022, 3338, 3681, 3813, 1926, 3064, 3224, 3263, 3337, 3544].filter((id) => !productIdsInCart.includes(id))
				this.upsellItems = await Mango.products({ search: { bcId: { $in: upsellIds } }, limit: 12 })
			} else {
				this.recommended = await this.getRelated(this.lastCartProduct)
			}
		},
		// async getDynamicRelatedProducts() {
		// 	const TOTAL_RELATED_PRODUCTS = 12
		// 	let relatedProducts = []

		// 	// If brandId exists, get products from the same brand
		// 	const brandId = this.lastCartProduct.brandId
		// 	const categories = this.lastCartProduct.categories || []

		// 	let brandProductsCount = 0
		// 	let categoryProductsNeeded = TOTAL_RELATED_PRODUCTS

		// 	// Step 1: Get products from the same brand if brandId exists
		// 	if (brandId) {
		// 		brandProductsCount = 4 // Default number of brand products to fetch

		// 		// Get products from the same brand, excluding the current product
		// 		const brandProducts = await this.fetchBrandProducts(brandId, brandProductsCount)
		// 		// If we got fewer brand products than expected, adjust the categoryProductsNeeded
		// 		brandProductsCount = brandProducts.length
		// 		categoryProductsNeeded = TOTAL_RELATED_PRODUCTS - brandProductsCount

		// 		// Add brand products to the relatedProducts array
		// 		relatedProducts = [...brandProducts]
		// 	}

		// 	// Step 2: Get products from categories to complete the set
		// 	if (categories.length > 0 && categoryProductsNeeded > 0) {
		// 		const categoryProducts = await this.fetchCategoryProducts(categories, categoryProductsNeeded)

		// 		relatedProducts = [...relatedProducts, ...categoryProducts]
		// 	}

		// 	// Return the combined list of related products, shuffled for randomness
		// 	return this.shuffleArray(relatedProducts).slice(0, TOTAL_RELATED_PRODUCTS)
		// },

		// async fetchBrandProducts(brandId, count) {
		// 	// Generate a random skip value for randomization
		// 	const randomSkip = Math.floor(Math.random() * 20)

		// 	// Fetch products from the same brand, excluding the current product and out-of-stock items
		// 	const brandProducts = await Mango.products({
		// 		search: {
		// 			categories: { $nin: ['66d8b83f6e195ee1d5e05680', '66d8b83f6e195ee1d5e0568a'] }, // exclude products from the birth kit categories
		// 			brandId: brandId,
		// 			_id: { $ne: this.lastCartProduct._id }, // Exclude the current product
		// 			outOfStock: { $ne: true }, // Exclude products marked as out of stock
		// 			isVisible: true,
		// 		},
		// 		limit: count + 25, // Fetch extra products to ensure we have enough after filtering out-of-stock items
		// 		skip: randomSkip, // Skip a random number of products for randomization
		// 		sort: { _id: Date.now() % 2 === 0 ? 1 : -1 }, // Random sort direction
		// 	})

		// 	// Further filter out products where all variants are out of stock
		// 	const inStockProducts = brandProducts.filter((product) => {
		// 		// If product doesn't track inventory by variant, it's already filtered by outOfStock above
		// 		if (product.inventoryTracking !== 'variant') return true

		// 		// Check if all variants are out of stock
		// 		return !product.variants?.every((v) => v.inventoryLevel <= 0)
		// 	})

		// 	// Shuffle the results for randomness and limit to the requested count
		// 	return this.shuffleArray(inStockProducts).slice(0, count)
		// },
		// async fetchCategoryProducts(categoryObjects, totalNeeded) {
		// 	const categories = categoryObjects.map((category) => category.id)

		// 	// Generate a random skip value for randomization
		// 	const randomSkip = Math.floor(Math.random() * 20)

		// 	// Query the database once for all categories using $in operator
		// 	// This is more efficient than querying each category separately
		// 	const categoryProducts = await Mango.products({
		// 		search: {
		// 			categories: {
		// 				$in: categories,
		// 				$nin: ['66d8b83f6e195ee1d5e05680', '66d8b83f6e195ee1d5e0568a'], // exclude products from the birth kit categories
		// 			},
		// 			_id: { $ne: this.lastCartProduct._id }, // Exclude the current product
		// 			outOfStock: { $ne: true }, // Exclude products marked as out of stock
		// 			isVisible: true,
		// 		},
		// 		limit: totalNeeded + 35, // Fetch more extra products to account for filtering out-of-stock items
		// 		skip: randomSkip, // Skip a random number of products for randomization
		// 		sort: { _id: Date.now() % 2 === 0 ? 1 : -1 }, // Random sort direction
		// 	})

		// 	// Filter out products where all variants are out of stock
		// 	const inStockCategoryProducts = categoryProducts.filter((product) => {
		// 		// If product doesn't track inventory by variant, it's already filtered by outOfStock above
		// 		if (product.inventoryTracking !== 'variant') return true

		// 		// Check if all variants are out of stock
		// 		return !product.variants?.every((v) => v.inventoryLevel <= 0)
		// 	})

		// 	// Shuffle the results for additional randomness
		// 	let allCategoryProducts = this.shuffleArray(inStockCategoryProducts).slice(0, totalNeeded)

		// 	// If we still do not have enough products, try a broader search
		// 	if (allCategoryProducts.length < totalNeeded) {
		// 		const remainingNeeded = totalNeeded - allCategoryProducts.length

		// 		// Generate a different random skip for fallback products
		// 		const randomFallbackSkip = Math.floor(Math.random() * 20)

		// 		// Get random products (not from this product brand or categories)
		// 		const randomProducts = await Mango.products({
		// 			search: {
		// 				_id: { $ne: this.lastCartProduct._id },
		// 				outOfStock: { $ne: true }, // Exclude products marked as out of stock
		// 				isVisible: true,
		// 			},
		// 			limit: remainingNeeded + 30, // Get more for better randomness and to account for filtering
		// 			skip: randomFallbackSkip, // Skip a random number of products for randomization
		// 		})

		// 		// Filter out any products we have already added and any out-of-stock variant products
		// 		const uniqueRandomProducts = randomProducts.filter((product) => {
		// 			// First check if it's already in our list
		// 			if (allCategoryProducts.some((p) => p._id === product._id)) return false

		// 			// Then check variant inventory if applicable
		// 			if (product.inventoryTracking === 'variant') {
		// 				return !product.variants?.every((v) => v.inventoryLevel <= 0)
		// 			}

		// 			return true
		// 		})

		// 		// Add the unique random products
		// 		allCategoryProducts = [...allCategoryProducts, ...this.shuffleArray(uniqueRandomProducts).slice(0, remainingNeeded)]
		// 	}

		// 	return allCategoryProducts
		// },

		// shuffleArray(array) {
		// 	// Fisher-Yates shuffle algorithm for randomizing array order
		// 	const newArray = [...array]
		// 	for (let i = newArray.length - 1; i > 0; i--) {
		// 		const j = Math.floor(Math.random() * (i + 1))
		// 		;[newArray[i], newArray[j]] = [newArray[j], newArray[i]]
		// 	}
		// 	return newArray
		// },

		// filterOutOfStock(products) {
		// 	return products.filter((product) => {
		// 		if (product.inventoryTracking !== 'variant') {
		// 			if (!product.outOfStock) return true
		// 			return false
		// 		}

		// 		return !product.variants?.every((v) => v.inventoryLevel <= 0)
		// 	})
		// },

		// filterProducts(products) {
		// 	// Get product IDs that are already in the cart
		// 	const productIdsInCart = this.store.cart?.cartItems?.map?.((c) => c.item.bcId) || []
		// 	productIdsInCart.push(3506) // artificially exclude 3506 by adding it to the "in cart" products

		// 	// Filter out products that are already in the cart and out of stock products
		// 	return this.filterOutOfStock(products.filter((product) => !productIdsInCart.includes(product.bcId)))
		// },

		resetScrollPosition() {
			// Use $nextTick to ensure the DOM has updated before trying to reset scroll
			this.$nextTick(() => {
				const grid = this.$refs.grid
				if (grid) {
					grid.scrollTop = 0
					this.updateScrollHint()
				}
			})
		},
		async getBoughtTogether(selectedProduct, n = 8, t = 0) {
			const id = selectedProduct.id

			const categoryFilters = selectedProduct.categories?.length ? [selectedProduct.categories.map((cat) => `categories:${cat?.name}`)] : [] // no facet fallback if none exist

			const { results } = await recommend.getRecommendations({
				requests: [
					{
						indexName: algoliaIndex,
						model: 'bought-together',
						objectID: id,
						maxRecommendations: n,
						threshold: t,
						queryParameters: {
							filters: 'outOfStock:false AND isVisible:true',
						},
						fallbackParameters: {
							facetFilters: [...categoryFilters],
							filters: 'outOfStock:false AND isVisible:true',
						},
					},
				],
			})

			// Filter out items already in the cart on the client side
			const productIdsInCart = this.store?.cart?.cartItems?.map?.((c) => c.item.bcId) || []
			const hits = results?.[0]?.hits || []
			return hits.filter((h) => !productIdsInCart.includes(h.bcId))
		},
		async getRelated(selectedProduct, n = 24, t = 0) {
			const id = selectedProduct.id
			const { results } = await recommend.getRecommendations({
				requests: [
					{
						indexName: algoliaIndex,
						model: 'related-products',
						objectID: id,
						maxRecommendations: n,
						threshold: t,
						queryParameters: {
							filters: 'outOfStock:false AND isVisible:true',
						},
					},
				],
			})
			// Filter out items already in the cart on the client side
			const productIdsInCart = this.store?.cart?.cartItems?.map?.((c) => c.item.bcId) || []
			const upsellItems = (results?.[0]?.hits || []).filter((h) => !productIdsInCart.includes(h.bcId))

			if (upsellItems.length < 12) {
				const boughtTogether = await this.getBoughtTogether(selectedProduct, 24 - upsellItems.length)
				return [...upsellItems, ...boughtTogether]
			}

			return upsellItems
		},
		// Update the subtle scroll hint visibility
		updateScrollHint() {
			this.$nextTick(() => {
				const grid = this.$refs.grid
				if (!grid) return
				const canScroll = grid.scrollHeight > grid.clientHeight
				const atBottom = grid.scrollTop + grid.clientHeight >= grid.scrollHeight - 2
				this.showScrollHint = canScroll && !atBottom
			})
		},
	},

	computed: {
		lastCartProduct() {
			return this.store?.cart?.cartItems?.[this.store?.cart?.cartItems?.length - 1]?.item
		},
		filteredProducts() {
			// if inventory tracking is variant, filter out products where all variants are out of stock. If inventory tracking is product, filter out products where inventory level is 0 or product.outOfStock is true.
			return this.recommended.filter((product) => {
				if (product.inventoryTracking === 'variant') {
					return !product.variants?.every((v) => v.inventoryLevel <= 0)
				} else {
					return !product.outOfStock && product.inventoryLevel > 0
				}
			})
		},
	},

	watch: {
		'store.cart.cartItems': {
			deep: true,
			immediate: true,
			handler: async function () {
				if (this.store?.addingFromUpsell) {
					this.store.addingFromUpsell = false
					return
				} else {
					await this.getUpsellItems()
					this.resetScrollPosition()
				}
			},
		},
	},

	mounted() {
		this.$nextTick(() => {
			const grid = this.$refs.grid
			if (grid) {
				grid.addEventListener('scroll', this.updateScrollHint)
				this.updateScrollHint()
			}
		})
	},

	beforeUnmount() {
		const grid = this.$refs.grid
		if (grid) grid.removeEventListener('scroll', this.updateScrollHint)
	},
}
</script>

<style lang="postcss" scoped>
/* This applies to child components */
.product-card-white :deep(.product-card) {
	@apply !bg-white;
}

/* Clamp product titles to 2 lines in this grid */
:deep(.line-clamp-2) {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	line-clamp: 2; /* compatibility */
}
</style>
